import { LaunchUniversal } from '@duxton-web/icons';
import { Button, Flex, Form, Select } from '@duxton-web/ui';
import _ from 'lodash';
import React from 'react';

import SegPWidget from 'omega-rtc/components/form/ucd/common/SegPWidget';
import {
  SEGMENT_NAMESPACE_OPTIONS,
  SMART_CAMPAIGN_FORM_KEYS,
} from 'omega-rtc/constants/ucd';

const SmartCampaignMetaDataUser: React.FC = () => {
  const form = Form.useFormInstance();
  const watchNamespace = Form.useWatch(
    SMART_CAMPAIGN_FORM_KEYS.SEGMENT_NAMESPACE,
    form,
  );
  const isSegpWidgetEnabled = _.get(
    window.Grab.config,
    'SEGP_WIDGET_ENABLED',
    true,
  );

  return (
    <Flex vertical>
      {isSegpWidgetEnabled && (
        <React.Fragment>
          <Form.Item
            required
            label="Namespace"
            initialValue={'all'}
            name={SMART_CAMPAIGN_FORM_KEYS.SEGMENT_NAMESPACE}
          >
            <Select options={SEGMENT_NAMESPACE_OPTIONS} placeholder="Select Namespace" />
          </Form.Item>

          <Form.Item
            name={SMART_CAMPAIGN_FORM_KEYS.SEGMENTS}
            required
            rules={[
              { message: '', required: true },
            ]}
          >
            <SegPWidget
              maxVisible={30}
              namespace={watchNamespace}
              enabledSegmentNSFormat
              showNsDropdown={false}
              segmentVal={form.getFieldValue(SMART_CAMPAIGN_FORM_KEYS.SEGMENTS)}
              onChange={(_, segmentSize, namespace, newSegmentVal) => {
                if (namespace && newSegmentVal) {
                  form.setFieldValue(
                    SMART_CAMPAIGN_FORM_KEYS.SEGMENTS,
                    `${namespace}.${newSegmentVal}`
                  );
                  form.setFieldValue(
                    SMART_CAMPAIGN_FORM_KEYS.SEGMENT_SIZE,
                    segmentSize,
                  );
                } else {
                  form.setFieldValue(
                    SMART_CAMPAIGN_FORM_KEYS.SEGMENTS,
                    undefined
                  );
                  form.setFieldValue(
                    SMART_CAMPAIGN_FORM_KEYS.SEGMENT_SIZE,
                    undefined,
                  );
                }
              }}
            />

          </Form.Item>
        </React.Fragment>
      )}
      <Button
        target="_blank"
        href={window.Grab.config.SEGMENTATION_PLATFORM_URI}
        style={{ marginRight: 8, marginBottom: 24, width: 'max-content' }}
        size="small"
      >
        Create new segment
        <LaunchUniversal />
      </Button>

      {_.get(window, 'Grab.config.PORTAL_CONFIG.holos.enabledTargetAudience', false) && (
        <Form.Item
          label="Target Audience"
          required
          name={SMART_CAMPAIGN_FORM_KEYS.AUDIENCE_TYPE}
          initialValue="local"
          rules={[{ message: 'Please select target audience', required: true }]}
        >
          <Select
            placeholder="Select target audience"
            options={[
              { value: 'local', label: 'Locals' },
              { value: 'traveller', label: 'Travellers' },
            ]}
          />
        </Form.Item>
      )}
    </Flex>
  );
};

export default SmartCampaignMetaDataUser;
